'use client'
import FieldText from '../field-text'
import FieldSelect from '../field-select'
import './style.scss'
import { computedClass } from 'utils'
import FiledCheckbox from '../field-checkbox'
import FieldCheckboxGroup from '../field-checkbox-group'
import { useEffect } from 'react'
import { patterns,telMask } from '../index'

const render = {
    number: (props) => <FieldText {...props} type="number"></FieldText>,
    text: (props) => <FieldText {...props}></FieldText>,
    list: (props) => <FieldSelect {...props}></FieldSelect>,
    enum: (props) => <FieldSelect {...props}></FieldSelect>,
    data: (props) => <FieldText {...props} date={true}></FieldText>,
    field_company: (props) => <FieldSelect {...props} ></FieldSelect>,
    checkbox: (props) => {
        const { UF_VALUE_LIST = [], text } = props
        if (UF_VALUE_LIST.length && !text) {
            return <FieldCheckboxGroup {...props} />
        }
        return <FiledCheckbox {...props} />
    },
}

function Field(props) {
    let { UF_FIELD_TYPE: type, UF_PLACEHOLDER: placeholder, UF_HIDDEN: hidden } = props
    let {
        typeMobile,
        useFormContext = {},
        widthOuter,
        widthInner,
        inputmode,
        required: _,
        ID,
        actions,
        descr,
        error: serverError,
        validation = {},
        UF_OBLIGATORY,
        UF_MASK: mask,
        name,
		  autofilled,
        ...rest
    } = props

    const { register, setValue, control, formState = {}, setError, getValues, onActionHandler } = useFormContext

    if (UF_OBLIGATORY) {
        validation = {
            required: 'Поле обязательно к заполнению',
        }
    }

	if(mask){
		validation = {
			...validation,
			pattern: {
				...patterns[mask],
		  },
		}
	}

    if (mask === 'tel') {
		mask = telMask()
    } else {
        mask = null
    }

    const { errors = {} } = formState

    const error = errors && errors[name]

    const classes = computedClass({
        field: true,
        hidden: hidden,
        'form-error': error,
		  'field--autofilled': autofilled,
        'field--fit': widthInner === 'fit',
        'field--fill': widthInner === 'fill' || !widthInner,
        'field--limit': widthInner === 'limit', 

    })

    const isCheckboxGroup = type === 'checkbox' && rest.UF_VALUE_LIST?.length && !rest.text
    const isPolicyCheckbox = type === 'checkbox' && !isCheckboxGroup

    const getProps = (type) => {
        let props = {}
        switch (type) {
            case 'checkbox':
                if (isCheckboxGroup) {
                    props = { required: validation?.required }
                } else {
                    props = {
                        ...(register && { ...register(name, validation) }),
                        ...(validation?.required && { required: true }),
                    }
                }
                break
            default:
                props = {
                    setValue,
                    ...(register && { ...register(name, validation) }),
                    ...(validation?.required && { required: true }),
                    placeholder,
                }
                break
        }
        return props
    }

    useEffect(() => {
        if (serverError) {
            setError(name, { type: 'server', message: serverError })
        }
    }, [serverError])


    return (
        <div className={classes}>
            {render[type] &&
                render[type]({
                    ...rest,
                    ...getProps(type),
                    name,
                    validation,
                    ...(error && { error }),
                    onActionHandler,
                    mask,
                    control,
                    ...(hidden && { type: 'hidden', hidden }),
                })}

            {error && !isPolicyCheckbox && (
                <div className="field__errors">
                    <div className="field__error flc">{error.message}</div>
                </div>
            )}
            {!error && descr && <div className="field__descr">{descr}</div>}
        </div>
    )
}

export default Field
